import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';

export default function NotFound() {
  const [params] = useSearchParams();
  const code = params.get('code');
  const reason = params.get('reason');

  return (
    <main className="min-h-screen bg-gradient-to-br from-brand-50 via-white to-purple-50 flex items-center justify-center px-4">
      <div className="text-center animate-slide-up max-w-md">
        <div className="text-8xl mb-6">🔗</div>
        <h1 className="text-4xl font-black text-gray-900 mb-3">
          {reason === 'expired' ? 'Link Expired' : 'Link Not Found'}
        </h1>
        {code && (
          <p className="text-gray-400 mb-2 font-mono text-sm bg-gray-100 rounded-lg px-3 py-1.5 inline-block">
            /{code}
          </p>
        )}
        <p className="text-gray-500 mt-3 mb-8 text-base leading-relaxed">
          {reason === 'expired'
            ? 'This short link has expired and is no longer accessible.'
            : "This short link doesn't exist or may have been deleted."}
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/" className="btn-secondary">← Go Home</Link>
          <Link to="/shorten" className="btn-primary">Create a New Link</Link>
        </div>
      </div>
    </main>
  );
}
